import PhotoSwipe from 'photoswipe';
import PhotoSwipeUiDefault from 'photoswipe/dist/photoswipe-ui-default';
import $photoswipeTemplate from '../../../javascripts/shared/photoswipe-template';
import {BREAKPOINTS} from '../../../javascripts/constants';

class Gallery {
  constructor($el) {
    this.$el = $el;

    this.init();

  }

  init() {
    this.$galleryImages = this.$el.querySelectorAll('.gallery-image__image');
    this.$photoswipeTemplate = $photoswipeTemplate.cloneNode(true);

    this.$galleryImages.forEach((galleryImage) => {
      galleryImage.addEventListener('click', (event) => {
        event.preventDefault();

        // Get target
        const $target = event.currentTarget;
        // Get current index
        const currentIndex = [...this.$galleryImages].indexOf($target);

        // Insert template
        document.body.appendChild(this.$photoswipeTemplate);

        const images = [...this.$galleryImages].map(($galleryImage) => {
          let title;

          if (!$galleryImage.getAttribute('data-title') && !$galleryImage.getAttribute('data-src')) {
            title = undefined;
          } else {
            title = `${$galleryImage.getAttribute('data-title') ? $galleryImage.getAttribute('data-title') : ''}
              ${$galleryImage.getAttribute('data-src') ? `<span class="figure__copyright"> ${$galleryImage.getAttribute('data-src')}` : ''}`;
          }
          return {
            src: $galleryImage.getAttribute('href'),
            w: $galleryImage.dataset.width,
            h: $galleryImage.dataset.height,
            title,
          };
        });

        const lastFocusedElement =  document.activeElement;

        // Init PhotoSwipe
        this.slideshow = new PhotoSwipe(
          this.$photoswipeTemplate,
          PhotoSwipeUiDefault,
          images,
          {
            index: currentIndex,
            bgOpacity: 0.8,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            mouseUsed: true,
            fullscreenEl: false,
            zoomEl: false,
            history: false,
          },
        );

        // After gallery is closed, destory DOM
        this.slideshow.listen('destroy', () => {
          this.$photoswipeTemplate.remove();
          this.$overlay.removeEventListener('keydown', this.handlePopupKeyDown);
          lastFocusedElement.focus();
        });

        // Start gallery
        this.slideshow.init();

        this.$overlay = document.querySelector('.pswp');
        this.focusPopup();

        // Optimized for 4:3 Ratio only!
        const setOffsetForCaption = () => {
          const percentage = 0.75;
          const initialtopOffset = document.querySelector('.pswp__ui').getBoundingClientRect().width * percentage;
          if (document.querySelector('.pswp__caption')) {
            document.querySelector('.pswp__caption').nextSibling.setAttribute('style', `top: ${initialtopOffset}px;`);
          }
        };
        setOffsetForCaption();
        window.addEventListener('resize', () => document.querySelector('.pswp__scroll-wrap') && setOffsetForCaption());
      });
    });
  }

  focusPopup() {
    let focusableEls = this.$overlay.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    focusableEls = Array.prototype.slice.call(focusableEls);

    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];

    setTimeout(() => {
      firstFocusableEl.setAttribute('tabindex', 1);
      firstFocusableEl.focus();
      // remove tabindex, because the tabbing order is destroyed
      firstFocusableEl.removeAttribute('tabindex');
    }, 500);

    this.handlePopupKeyDown = function (e) {
      const KEY_TAB = 9;

      function handleBackwardTab() {
        if (document.activeElement === firstFocusableEl) {
          e.preventDefault();
          lastFocusableEl.focus();
        }
      }

      function handleForwardTab() {
        if (document.activeElement === lastFocusableEl) {
          e.preventDefault();
          firstFocusableEl.focus();
        }
      }

      switch (e.keyCode) {
        case KEY_TAB:
          if (focusableEls.length === 1) {
            e.preventDefault();
            break;
          }

          if (e.shiftKey) {
            handleBackwardTab();
          } else {
            handleForwardTab();
          }
          break;
        default:
          break;
      }
    }

    this.$overlay.addEventListener('keydown', this.handlePopupKeyDown);
  }


}

document.querySelectorAll('.js-gallery').forEach(
  $el => new Gallery($el),
);



// WEBPACK FOOTER //
// ./src/components/organisms/gallery/gallery.js